import React from 'react';
import type { CollectButtonSource } from '@soundxyz/utils/analytics';
import { Button } from '@components/main-components/button/Button';
import { useConnectedAuth } from '@context/auth/connected';
import { trackClickEvent } from '@lib/analytics';
import { DataTestId } from '@utils/test';

export const ConnectWallet = ({
  label = 'Sign in',
  fullWidth,
  size = 'XL',
  sourceComponent,
}: {
  label?: string;
  fullWidth?: boolean;
  size?: React.ComponentProps<typeof Button>['size'];
  sourceComponent: CollectButtonSource;
}) => {
  const { login, isAuthenticating } = useConnectedAuth();

  return (
    <Button
      data-testid={DataTestId.RELEASE_PAGE_CONNECT_BUTTON}
      variant="primary"
      fullWidth={fullWidth}
      label={label}
      size={size}
      loading={isAuthenticating}
      onClick={() => {
        trackClickEvent({
          event: 'Sign in Clicked',
          properties: {
            sourceComponent,
          },
        });
        login();
      }}
    />
  );
};

export const Collect = ({
  fullWidth,
  disabled,
  loading,
  onClick,
  soldOut = false,
  variant = 'primary',
  size = 'XL',
}: {
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  soldOut?: boolean;
  variant?: React.ComponentProps<typeof Button>['variant'];
  size?: React.ComponentProps<typeof Button>['size'];
}) => (
  <Button
    data-testid={DataTestId.RELEASE_PAGE_COLLECT_BUTTON}
    variant={variant}
    fullWidth={fullWidth}
    label={soldOut ? 'Sold Out' : 'Collect Now'}
    size={size}
    disabled={disabled}
    loading={loading}
    onClick={onClick}
  />
);
